import { Injectable } from '@angular/core';

import { ShReportService } from '@stylehaven/components';
import { of } from 'rxjs';

@Injectable()
export class ReportService extends ShReportService {
    protected readonly ENDPOINT = 'v1/reports';

    protected override initDefaults(): void {
        this.defaultCollection$ = of(undefined);
        this.defaultDashboard$ = of(undefined);
    }
}
